<mat-list-item class="row no-gutters full-width mat-list-item-content-at-full-width template-padding"
               [disableRipple]="true">
    <div class="col-sm-12">
        <div class="row no-gutters mt-2">
            <div class="col-sm-11 col-md-5 col-lg-5 mt-2 mr-1 template-title-container">
                 <i class="dr-fa-icon fa fa-ellipsis-v"></i>

                 <input id="{{idPrefix}}display_name"
                        type="text" matInput
                        class="no-borders full-width template-title"
                        [(ngModel)]="template.display_name"
                        (blur)="patchValue('display_name', template.display_name)"
                        [disabled]="disabled">
            </div>

            <div class="col-md-2 col-lg-2 mt-2 mr-1">
                <mat-select id="{{idPrefix}}document_type"
                            [(ngModel)]="template.document_type"
                            (ngModelChange)="patchValue('document_type', template.document_type)"
                            [disabled]="disabled"
                            [panelClass]="'document-type-select-panel'">
                    <mat-option *ngFor="let fileCat of caseFileCategories" [value]="fileCat.key"
                                id="{{idPrefix}}document_type.{{fileCat.key}}">
                        {{ fileCat.trans | translate }}
                    </mat-option>
                </mat-select>
            </div>

            <div class="ml-auto mt-2">
                <a id="{{idPrefix}}btn.toggle_history"
                   class="iq-link-style cursive ml-4"
                   (click)="toggleHistoryPanel()">
                    <span class="">{{ 'template_management.btn.versions'  | translate }}</span>
                </a>

                <i *ngIf="!template.hidden"
                   id="{{idPrefix}}btn.hide"
                   class="dr-fa-icon fas fa-lg fa-eye ml-4"
                   matTooltip="{{ 'common.label.hide' | translate }}"
                   (click)="patchValue('hidden', !template.hidden)">
                </i>

                <i *ngIf="template.hidden"
                   id="{{idPrefix}}btn.show"
                   class="dr-fa-icon fas fa-lg fa-eye-slash ml-4"
                   matTooltip="{{ 'common.label.show' | translate }}"
                   (click)="patchValue('hidden', !template.hidden)">
                </i>

                <i id="{{idPrefix}}btn.download"
                   class="dr-fa-icon fas fa-lg fa-download ml-4"
                   matTooltip="{{ 'common.label.download' | translate }}"
                   (click)="downloadLatestTemplateVersion()">
                </i>

                <file-select class="dr-fa-icon ml-4"
                             [idPrefix]="idPrefix"
                             [acceptedFiles]="acceptedFilesTypes"
                             [favicon]="'dr-fa-icon fas fa-lg fa-upload'"
                             [label]="'common.label.upload' | translate"
                             [multi]="false"
                             (filesSelected)="uploadNewTemplateVersion($event)">
                </file-select>

                <i id="{{idPrefix}}btn.delete"
                   class="dr-fa-icon fas fa-lg fa-times ml-4"
                   matTooltip="{{ 'common.label.delete' | translate }}"
                   (click)="deleteTemplate()">
                </i>
            </div>
        </div>

        <div class="mb-3"
             *ngIf="showVersions">

            <div class="row no-gutters mt-3 version-row title">
                <div class="col-sm-1">
                    <span>{{ template.versions[0].trans.version | translate }}</span>
                </div>
                <div class="col-sm-3">
                    <span>{{ template.versions[0].trans.lastmodified | translate }}</span>
                </div>
                <div class="col-sm-2">
                    <span>{{ template.versions[0].trans.lastmodifiedby | translate }}</span>
                </div>
                <div class="col-sm-4">
                    <span>{{ template.versions[0].trans.description | translate }}</span>
                </div>
                <div class="col-sm-2">
                    <span>{{ 'common.label.actions' | translate }}</span>
                </div>
            </div>

            <div class="row no-gutters version-row pt-1 pb-1" *ngFor="let version of template.versions;">
                <div class="col-sm-1">
                    <span>v{{ version.version }}</span>
                    <span *ngIf="version === template.activeVersion" class="iq-color-2"> ({{ version.trans.current | translate }})</span>
                </div>
                <div class="col-sm-3">
                    <span>{{ version.lastmodified | drDateTime }}</span>
                </div>
                <div class="col-sm-2">
                    <span>{{ version.lastmodifiedby }}</span>
                </div>
                <div class="col-sm-4">
                    <span>{{ version.description }}</span>
                </div>
                <div class="col-sm-2">
                    <div *ngIf="version !== template.activeVersion">
                        <a id="{{idPrefix}}version_{{version.version}}.btn.restore"
                           class="iq-link-style cursive"
                           (click)="restoreVersion(version)">
                            <span class="">{{ 'common.btn.restore'  | translate }}</span>
                        </a>
                        <a id="{{idPrefix}}version_{{version.version}}.btn.delete"
                           class="iq-link-style cursive ml-3"
                           (click)="deleteVersion(version)">
                            <span class="">{{ 'common.btn.delete'  | translate }}</span>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>

</mat-list-item>
